import { Box, Grid } from '@mui/material';
import React from 'react';
import TotalCard from '../../../components/foodCards/totalCard';
import ActiveCard from '../../../components/foodCards/activeCard';
import InactiveCard from '../../../components/foodCards/inactiveCard';
import { useFoodCategorys } from '../../../customHooks/useFoodCategory';

const Cards = () => {
  const { activeCategories, allCategories, inActiveCategories } =
    useFoodCategorys();
  return (
    <>
      <Box>
        <Grid container spacing={{ xs: 2, md:33,lg:'280px' ,xl:40}}>
          <Grid item xs={12} sm={4} md={2}   >
            <TotalCard total={allCategories} thing={'Categories'} />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <ActiveCard total={activeCategories} thing={'Categories'} />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <InactiveCard total={inActiveCategories} thing={'Categories'} />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Cards;
